// API para Conferência de NFe
import api from './client';

// Tipos
export interface ConferenciaListItem {
  empresa: string;
  codigoId: string;
  status: string;
  dataConferencia: string;
  usuario: string;
  numeroNfe: string;
  fornecedor: string;
}

export interface ConferenciaDetalhes {
  empresa: string;
  codigoId: string;
  status: string;
  dataConferencia: string;
  usuario: string;
  observacao: string;
  numeroNfe: string;
  fornecedor: string;
  produtos: ConferenciaProduto[];
}

export interface ConferenciaProduto {
  produto: string;
  qtdeConferida: number;
  qtdeEmbalagem: number;
  status: string;
  descricaoProduto: string;
}

export interface NfeConferencia {
  numeroNfe: string;
  chaveNfe: string;
  dataEmissao: string;
  fornecedor: string;
  valorTotal: number;
  status: string;
  produtos: ProdutoNfe[];
}

export interface ProdutoNfe {
  codigo: string;
  descricao: string;
  quantidade: number;
  unidade: string;
  valorUnitario: number;
  valorTotal: number;
  ean?: string;
}

export interface ProdutoBarras {
  produtoPrincipal: string;
  descricao: string;
  ean: string;
  unidade: string;
  precoVenda: number;
  ativo: string;
}

export interface CriarConferenciaRequest {
  empresa: string;
  dataConferencia?: string;
  usuario?: string;
  observacao?: string;
  produtos?: {
    produto: string;
    qtdeConferida?: number;
    qtdeEmbalagem?: number;
    status?: string;
  }[];
}

export interface AtualizarConferenciaRequest {
  dataConferencia?: string;
  usuario?: string;
  observacao?: string;
  status?: string;
  produtos?: {
    produto: string;
    qtdeConferida?: number;
    qtdeEmbalagem?: number;
    status?: string;
  }[];
}

// Funções da API
export const conferenciaApi = {
  // Listar todas as conferências
  listarConferencias: async (): Promise<ConferenciaListItem[]> => {
    const response = await api.get('/ConferenciaNfe');
    return response.data;
  },

  // Obter conferência específica
  obterConferencia: async (empresa: string, codigoId: string): Promise<ConferenciaDetalhes> => {
    const response = await api.get(`/ConferenciaNfe/${empresa}/${codigoId}`);
    return response.data;
  },

  // Buscar NFe por DANFE
  buscarNfePorDanfe: async (danfe: string): Promise<NfeConferencia> => {
    const response = await api.get(`/ConferenciaNfe/nfe/${danfe}`);
    return response.data;
  },

  // Buscar produto por código de barras
  buscarProdutoPorBarras: async (codigoBarras: string): Promise<ProdutoBarras> => {
    const response = await api.get(`/ConferenciaNfe/produto/barras/${codigoBarras}`);
    return response.data;
  },

  // Criar nova conferência
  criarConferencia: async (dados: CriarConferenciaRequest): Promise<{ codigoId: string }> => {
    const response = await api.post('/ConferenciaNfe', dados);
    return response.data;
  },

  // Atualizar conferência
  atualizarConferencia: async (
    empresa: string,
    codigoId: string,
    dados: AtualizarConferenciaRequest
  ): Promise<void> => {
    await api.put(`/ConferenciaNfe/${empresa}/${codigoId}`, dados);
  },

  // Remover conferência
  removerConferencia: async (empresa: string, codigoId: string): Promise<void> => {
    await api.delete(`/ConferenciaNfe/${empresa}/${codigoId}`);
  },
};

export default conferenciaApi;